export const DIVISAO_EQUITATIVA_PARAMS = {
	USUARIO_AUTENTICACAO: 'BALCAO_UNICO',
};
